/**
 * GENERATED — do not edit by hand. Regenerate with
 * `npx tsx scripts/gen-baloo-metrics.ts` (see that file for the why),
 * and note that `guards/baloo-metrics.test.ts` re-derives every number
 * below from `workers/assets/Baloo2-400Regular.ttf` and fails on drift.
 *
 * BALOO 2 REGULAR'S OWN ADVANCE WIDTHS. This is not a model of a font and
 * not a fitted approximation: it is the `hmtx` table of the exact `.ttf`
 * the thumbnail rasterizer bundles, indexed through that file's own
 * `cmap`. Validated against two independent measurers on 2026-09-03:
 * Chrome's `measureText` with the face loaded and `fontKerning: "none"`
 * reproduces sums from this table to 3e-7 em, and the same parser run
 * over Baloo 2 SemiBold reproduces all seven CoreText measurements
 * recorded in `app/src/textMeasure.ts` — taken on an iPhone, by Apple's
 * text engine — to four decimal places.
 *
 * 856 code points, every one the face carries.
 * Anything outside this list has no glyph in Baloo at all; `textWidth.ts`
 * charges it a full em and says there why.
 */

/** Font design units per em. Every number in this file is in these. */
export const BALOO2_UNITS_PER_EM = 1000;

/** hhea ascender / descender (descender positive here). Their sum is the
 *  face's designed line box — 1.602 em, which is much taller than Latin
 *  ink actually reaches; see `textWidth.ts` for the measured ink extents
 *  and why the renderer sets its own leading rather than using these. */
export const BALOO2_ASCENDER = 1078;
export const BALOO2_DESCENDER = 524;

/** Glyph 0's advance — what resvg draws for a character the face lacks. */
export const BALOO2_NOTDEF_ADVANCE = 645;

/** Flat `[codePoint, advance, codePoint, advance, …]`, ascending by code
 *  point. Flat rather than an object literal so it is one array to read
 *  and one array to diff; the Map is built once, lazily, next door. */
export const BALOO2_ADVANCES: readonly number[] = [
  13, 223, 32, 200, 33, 250, 34, 270, 35, 667, 36, 522, 37, 772, 38, 637, 39,
  139, 40, 254, 41, 254, 42, 299, 43, 548, 44, 145, 45, 389, 46, 141, 47, 305,
  48, 583, 49, 357, 50, 508, 51, 506, 52, 548, 53, 538, 54, 550, 55, 458, 56,
  569, 57, 552, 58, 189, 59, 202, 60, 473, 61, 518, 62, 460, 63, 459, 64, 1000,
  65, 592, 66, 599, 67, 588, 68, 652, 69, 531, 70, 517, 71, 639, 72, 654, 73,
  262, 74, 385, 75, 566, 76, 501, 77, 780, 78, 660, 79, 689, 80, 567, 81, 690,
  82, 589, 83, 523, 84, 523, 85, 649, 86, 583, 87, 803, 88, 591, 89, 550, 90,
  557, 91, 268, 92, 341, 93, 269, 94, 463, 95, 465, 96, 302, 97, 499, 98, 549,
  99, 478, 100, 547, 101, 519, 102, 399, 103, 537, 104, 551, 105, 241, 106, 243,
  107, 487, 108, 246, 109, 816, 110, 550, 111, 553, 112, 546, 113, 546, 114,
  382, 115, 447, 116, 372, 117, 550, 118, 495, 119, 729, 120, 482, 121, 489,
  122, 469, 123, 281, 124, 251, 125, 281, 126, 448, 127, 0, 160, 200, 161, 250,
  162, 476, 163, 504, 164, 525, 165, 546, 166, 293, 167, 504, 168, 374, 169,
  713, 170, 352, 171, 469, 172, 542, 173, 389, 174, 619, 175, 328, 176, 360,
  177, 548, 178, 276, 179, 272, 180, 298, 181, 552, 182, 441, 183, 141, 184,
  195, 185, 211, 186, 378, 187, 469, 188, 602, 189, 621, 190, 647, 191, 459,
  192, 592, 193, 592, 194, 592, 195, 592, 196, 592, 197, 592, 198, 844, 199,
  588, 200, 542, 201, 542, 202, 542, 203, 542, 204, 262, 205, 262, 206, 262,
  207, 262, 208, 682, 209, 660, 210, 689, 211, 689, 212, 689, 213, 689, 214,
  689, 215, 495, 216, 689, 217, 649, 218, 649, 219, 649, 220, 649, 221, 550,
  222, 575, 223, 577, 224, 499, 225, 499, 226, 499, 227, 499, 228, 499, 229,
  499, 230, 811, 231, 478, 232, 519, 233, 519, 234, 519, 235, 519, 236, 241,
  237, 241, 238, 241, 239, 241, 240, 537, 241, 560, 242, 553, 243, 553, 244,
  553, 245, 553, 246, 553, 247, 522, 248, 553, 249, 550, 250, 550, 251, 550,
  252, 550, 253, 489, 254, 553, 255, 489, 256, 592, 257, 499, 258, 592, 259,
  499, 260, 592, 261, 499, 262, 588, 263, 478, 264, 588, 265, 478, 266, 588,
  267, 478, 268, 588, 269, 478, 270, 652, 271, 624, 272, 691, 273, 550, 274,
  542, 275, 519, 276, 542, 277, 519, 278, 542, 279, 519, 280, 542, 281, 519,
  282, 542, 283, 519, 284, 639, 285, 537, 286, 639, 287, 537, 288, 639, 289,
  537, 290, 639, 291, 537, 292, 645, 293, 557, 294, 654, 295, 558, 296, 262,
  297, 241, 298, 262, 299, 241, 300, 262, 301, 241, 302, 262, 303, 241, 304,
  262, 305, 241, 306, 647, 307, 484, 308, 372, 309, 238, 310, 557, 311, 487,
  312, 487, 313, 501, 314, 246, 315, 501, 316, 246, 317, 501, 318, 317, 319,
  501, 320, 316, 321, 521, 322, 325, 323, 651, 324, 550, 325, 651, 326, 550,
  327, 651, 328, 550, 329, 627, 330, 660, 331, 550, 332, 689, 333, 553, 334,
  689, 335, 553, 336, 689, 337, 553, 338, 953, 339, 887, 340, 589, 341, 382,
  342, 589, 343, 382, 344, 589, 345, 382, 346, 523, 347, 447, 348, 523, 349,
  447, 350, 523, 351, 447, 352, 523, 353, 447, 354, 523, 355, 372, 356, 523,
  357, 453, 358, 523, 359, 372, 360, 649, 361, 551, 362, 649, 363, 550, 364,
  649, 365, 551, 366, 649, 367, 550, 368, 649, 369, 550, 370, 649, 371, 550,
  372, 799, 373, 712, 374, 550, 375, 489, 376, 550, 377, 557, 378, 469, 379,
  557, 380, 469, 381, 557, 382, 469, 399, 650, 402, 506, 416, 696, 417, 581,
  431, 681, 432, 593, 452, 1195, 453, 1121, 454, 1016, 455, 900, 456, 744, 457,
  489, 458, 1045, 459, 903, 460, 793, 461, 592, 462, 499, 463, 262, 464, 241,
  465, 689, 466, 553, 467, 649, 468, 550, 469, 649, 470, 550, 471, 649, 472,
  550, 473, 649, 474, 550, 475, 649, 476, 550, 486, 639, 487, 537, 490, 689,
  491, 553, 506, 592, 507, 499, 508, 844, 509, 811, 510, 689, 511, 553, 512,
  592, 513, 499, 514, 592, 515, 499, 516, 531, 517, 519, 518, 531, 519, 519,
  520, 262, 521, 267, 522, 262, 523, 241, 524, 689, 525, 553, 526, 689, 527,
  553, 528, 589, 529, 382, 530, 589, 531, 382, 532, 649, 533, 550, 534, 649,
  535, 550, 536, 523, 537, 447, 538, 523, 539, 372, 554, 689, 555, 553, 556,
  689, 557, 553, 560, 689, 561, 553, 562, 550, 563, 489, 567, 243, 593, 552,
  601, 516, 609, 537, 699, 129, 700, 127, 702, 175, 703, 175, 710, 348, 711,
  350, 712, 342, 713, 322, 714, 309, 715, 292, 716, 382, 728, 336, 729, 206,
  730, 286, 731, 235, 732, 374, 733, 488, 768, 0, 769, 0, 770, 0, 771, 0, 772,
  0, 774, 0, 775, 0, 776, 0, 777, 0, 778, 0, 779, 0, 780, 0, 783, 0, 785, 0,
  786, 0, 795, 0, 803, 0, 804, 0, 806, 0, 807, 0, 808, 0, 814, 0, 817, 0, 960,
  626, 2304, 0, 2305, 0, 2306, 0, 2307, 214, 2308, 719, 2309, 719, 2310, 967,
  2311, 534, 2312, 544, 2313, 478, 2314, 726, 2315, 749, 2316, 758, 2317, 558,
  2318, 558, 2319, 558, 2320, 558, 2321, 967, 2322, 967, 2323, 967, 2324, 967,
  2325, 777, 2326, 782, 2327, 567, 2328, 618, 2329, 625, 2330, 630, 2331, 692,
  2332, 672, 2333, 772, 2334, 644, 2335, 504, 2336, 571, 2337, 534, 2338, 560,
  2339, 717, 2340, 572, 2341, 639, 2342, 552, 2343, 644, 2344, 542, 2345, 542,
  2346, 541, 2347, 778, 2348, 574, 2349, 590, 2350, 584, 2351, 608, 2352, 399,
  2353, 399, 2354, 726, 2355, 751, 2356, 751, 2357, 558, 2358, 693, 2359, 551,
  2360, 703, 2361, 520, 2362, 0, 2363, 249, 2364, 0, 2365, 519, 2366, 249, 2367,
  249, 2368, 249, 2369, 0, 2370, 0, 2371, 0, 2372, 0, 2373, 0, 2374, 0, 2375, 0,
  2376, 0, 2377, 249, 2378, 249, 2379, 249, 2380, 249, 2381, 0, 2382, 227, 2383,
  249, 2384, 850, 2385, 0, 2386, 0, 2387, 0, 2388, 0, 2389, 0, 2390, 0, 2391, 0,
  2392, 777, 2393, 782, 2394, 567, 2395, 672, 2396, 512, 2397, 566, 2398, 778,
  2399, 608, 2400, 786, 2401, 761, 2402, 0, 2403, 0, 2404, 355, 2405, 596, 2406,
  509, 2407, 440, 2408, 489, 2409, 509, 2410, 554, 2411, 538, 2412, 513, 2413,
  637, 2414, 475, 2415, 460, 2416, 430, 2417, 219, 2418, 723, 2419, 719, 2420,
  967, 2421, 967, 2422, 719, 2423, 719, 2424, 533, 2425, 685, 2426, 608, 2427,
  540, 2428, 692, 2429, 464, 2430, 538, 2431, 545, 7688, 588, 7689, 478, 7692,
  652, 7693, 545, 7694, 652, 7695, 545, 7700, 531, 7701, 519, 7702, 531, 7703,
  519, 7708, 531, 7709, 519, 7712, 639, 7713, 537, 7716, 645, 7717, 529, 7722,
  645, 7723, 529, 7726, 262, 7727, 241, 7734, 501, 7735, 246, 7736, 501, 7737,
  246, 7738, 501, 7739, 246, 7746, 780, 7747, 797, 7748, 651, 7749, 550, 7750,
  660, 7751, 550, 7752, 660, 7753, 550, 7756, 689, 7757, 553, 7758, 689, 7759,
  553, 7760, 689, 7761, 553, 7762, 689, 7763, 553, 7770, 589, 7771, 393, 7772,
  589, 7773, 385, 7774, 589, 7775, 393, 7776, 531, 7777, 447, 7778, 531, 7779,
  447, 7780, 523, 7781, 447, 7782, 523, 7783, 447, 7784, 523, 7785, 447, 7788,
  523, 7789, 372, 7790, 523, 7791, 372, 7800, 649, 7801, 551, 7802, 649, 7803,
  550, 7808, 799, 7809, 712, 7810, 799, 7811, 712, 7812, 799, 7813, 712, 7822,
  550, 7823, 489, 7826, 557, 7827, 469, 7831, 372, 7838, 604, 7840, 592, 7841,
  499, 7842, 592, 7843, 499, 7844, 592, 7845, 499, 7846, 592, 7847, 499, 7848,
  592, 7849, 499, 7850, 592, 7851, 499, 7852, 592, 7853, 499, 7854, 592, 7855,
  499, 7856, 592, 7857, 499, 7858, 592, 7859, 499, 7860, 592, 7861, 499, 7862,
  592, 7863, 499, 7864, 542, 7865, 519, 7866, 542, 7867, 519, 7868, 542, 7869,
  519, 7870, 542, 7871, 529, 7872, 542, 7873, 529, 7874, 542, 7875, 529, 7876,
  542, 7877, 519, 7878, 542, 7879, 519, 7880, 262, 7881, 241, 7882, 262, 7883,
  241, 7884, 689, 7885, 553, 7886, 689, 7887, 553, 7888, 662, 7889, 553, 7890,
  662, 7891, 553, 7892, 662, 7893, 553, 7894, 689, 7895, 553, 7896, 689, 7897,
  553, 7898, 691, 7899, 574, 7900, 691, 7901, 574, 7902, 691, 7903, 574, 7904,
  691, 7905, 574, 7906, 691, 7907, 574, 7908, 649, 7909, 550, 7910, 649, 7911,
  550, 7912, 681, 7913, 592, 7914, 681, 7915, 592, 7916, 681, 7917, 592, 7918,
  681, 7919, 592, 7920, 681, 7921, 592, 7922, 550, 7923, 489, 7924, 550, 7925,
  491, 7926, 550, 7927, 489, 7928, 550, 7929, 489, 8199, 583, 8200, 141, 8201,
  150, 8202, 90, 8203, 0, 8204, 0, 8205, 0, 8208, 389, 8210, 534, 8211, 534,
  8212, 767, 8213, 767, 8216, 129, 8217, 127, 8218, 131, 8220, 263, 8221, 263,
  8222, 263, 8224, 424, 8225, 425, 8226, 263, 8230, 469, 8240, 1120, 8242, 139,
  8243, 269, 8249, 279, 8250, 279, 8260, 122, 8304, 318, 8308, 293, 8309, 282,
  8310, 301, 8311, 236, 8312, 306, 8313, 300, 8317, 150, 8318, 150, 8319, 373,
  8320, 318, 8321, 211, 8322, 276, 8323, 272, 8324, 293, 8325, 282, 8326, 301,
  8327, 236, 8328, 306, 8329, 300, 8333, 150, 8334, 150, 8353, 610, 8355, 517,
  8356, 504, 8358, 698, 8359, 1145, 8361, 803, 8362, 773, 8363, 551, 8364, 614,
  8365, 566, 8366, 523, 8369, 652, 8370, 639, 8373, 588, 8377, 526, 8378, 534,
  8380, 669, 8381, 599, 8467, 422, 8470, 992, 8471, 713, 8480, 692, 8482, 667,
  8486, 708, 8494, 774, 8531, 631, 8532, 681, 8539, 633, 8540, 672, 8541, 679,
  8542, 609, 8592, 694, 8593, 393, 8594, 694, 8595, 393, 8706, 528, 8709, 713,
  8710, 592, 8719, 585, 8721, 511, 8722, 518, 8725, 422, 8729, 263, 8730, 557,
  8734, 796, 8747, 405, 8776, 521, 8800, 520, 8804, 518, 8805, 518, 9632, 654,
  9650, 626, 9651, 626, 9654, 629, 9655, 629, 9660, 626, 9661, 626, 9664, 629,
  9665, 629, 9670, 614, 9674, 592, 9676, 628, 43259, 249, 64256, 783, 64257,
  640, 64258, 645, 64259, 988, 64260, 1029,
];
